module.exports = __webpack_public_path__ + "img/Bodice-Back-Jb-Ke-Lc.4925bb4d.png";